module.exports = __webpack_public_path__ + "media/images/smart_phone/ranking_bg_btm-b3a6c2b27409d40bfe39925754ac5469.gif";